import { createContext } from 'react';

const AbilityContext = createContext();

export default AbilityContext;